import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Modules() {
  const modules = [{
    icon: '📘',
    title: 'Tomo 1 — El Sistema Maestro de Costos',
    desc: 'Método del kilo, factor de desperdicio y fórmula final. Nunca más perdés plata en material.'
  }, {
    icon: '📗',
    title: 'Tomo 2 — Manual de Mano de Obra y Complejidad',
    desc: 'Valor hora real y tablas por obra. Cobrás lo que vale tu tiempo.'
  }, {
    icon: '📙',
    title: 'Tomo 3 — El Conversor Maestro de Pesos y Perfiles',
    desc: 'Tablas de caños, hierros y perfiles. Calculás material en segundos sin errores.'
  }, {
    icon: '📕',
    title: 'Tomo 4 — Blindaje Anti-Inflación Avanzado',
    desc: 'Cláusula gatillo, seña inteligente e índice del kilo. La inflación no te come más.'
  }, {
    icon: '📓',
    title: 'Tomo 5 — Catálogo de Ventas y Cierres',
    desc: 'Argumentario, cierres por WhatsApp y manejo de objeciones. Vendés más y mejor.'
  }, {
    icon: '📔',
    title: 'Tomo 6 — Checklists de Taller y Entrega',
    desc: 'Control de calidad y actas de entrega. Cero reclamos evitables.'
  }];
  const includes = ['Tablas listas para imprimir', 'Fórmulas paso a paso', 'Checklists de verificación', 'Printable A4 para el taller'];
  return <section className="py-12 bg-surface border-y border-white/5" data-id="element-173">
      <div className="container mx-auto px-4" data-id="element-174">
        <FadeIn data-id="element-175">
          <div className="text-center mb-10" data-id="element-176">
            <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-177">
              🏆 MEGAPACK HERRERÍA BLINDADA
            </h2>
            <p className="text-xl text-gold font-medium mb-2" data-id="element-178">
              6 Tomos + 3 Bonos
            </p>
            <p className="text-gray-400" data-id="element-179">
              200+ páginas de tablas, fórmulas, planos y protocolos. Todo
              resuelto.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10" data-id="element-180">
          {modules.map((mod, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-181">
              <div className="bg-background p-6 rounded-2xl border border-white/10 hover:border-gold/50 transition-colors group h-full" data-id="element-182">
                <div className="text-4xl mb-4 group-hover:scale-110 transition-transform origin-left" data-id="element-183">
                  {mod.icon}
                </div>
                <h3 className="text-lg font-bold mb-2 text-white leading-tight" data-id="element-184">
                  {mod.title}
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-185">{mod.desc}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} data-id="element-186">
          <div className="bg-background/50 p-8 rounded-2xl border border-white/5 max-w-4xl mx-auto" data-id="element-187">
            <h4 className="text-center text-lg text-gray-300 mb-6 font-medium" data-id="element-188">
              Cada tomo incluye:
            </h4>
            <div className="grid sm:grid-cols-2 gap-4" data-id="element-189">
              {includes.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-190">
                  <CheckCircle2 className="w-5 h-5 text-gold shrink-0" data-id="element-191" />
                  <span className="text-gray-200" data-id="element-192">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}